module.exports = __webpack_public_path__ + "img/s1-img3.3726d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s1-img3.png
// module id = 403
// module chunks = 0